import { useRef } from 'react';
import { useNavigate } from 'react-router';
import type { OrderListItem } from '@/api/types';
import { Icon } from '@/components/Icon';
import { WorkCard, type WorkCardSettings } from './OrderCards';
import s from './SwipeOrderCard.module.css';

export function SwipeOrderCard({ order, settings, open, canApprove, onOpen, onLongPress }: {
  order: OrderListItem;
  settings: WorkCardSettings;
  open: boolean;
  canApprove: boolean;
  onOpen: (id: string | null) => void;
  onLongPress: () => void;
}) {
  const nav = useNavigate();
  const start = useRef<{ x: number; y: number } | null>(null);
  const suppressClick = useRef(false);
  const approve = canApprove && order.status === 'SUBMITTED';
  const go = (action: 'approve' | 'more') => { onOpen(null); nav(`/orders/${order.id}?${action}=1`); };
  return <div className={`${s.wrap} ${open ? s.open : ''}`}
    onPointerDown={(event) => { if (event.pointerType !== 'mouse') start.current = { x: event.clientX, y: event.clientY }; }}
    onPointerUp={(event) => {
      const from = start.current;
      start.current = null;
      if (!from) return;
      const dx = event.clientX - from.x;
      const dy = event.clientY - from.y;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      suppressClick.current = true;
      window.setTimeout(() => { suppressClick.current = false; }, 100);
      onOpen(dx < 0 ? order.id : null);
    }}
    onPointerCancel={() => { start.current = null; }}
    onClickCapture={(event) => { if (suppressClick.current) { event.preventDefault(); event.stopPropagation(); suppressClick.current = false; } }}>
    <div className={s.actions}><button type="button" onClick={() => go('more')}><Icon name="more" size={20} />更多</button><button type="button" className={s.primary} onClick={() => approve ? go('approve') : nav(`/orders/${order.id}`)}><Icon name={approve ? 'check' : 'chev'} size={20} />{approve ? '审核' : '查看'}</button></div>
    <div className={s.front}><WorkCard o={order} to={`/orders/${order.id}`} settings={settings} onLongPress={onLongPress} /></div>
  </div>;
}
